import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Search as SearchIcon, Phone, Mail } from "lucide-react";

const MobileSearch = () => {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/students").then((r) => setAll(r.data)).catch(() => {});
  }, []);

  const results = q.length < 2 ? all.slice(0, 20) : all.filter((s) =>
    (s.full_name || "").toLowerCase().includes(q.toLowerCase()) ||
    (s.admission_no || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="px-4 pt-4 pb-6" data-testid="mobile-search-page">
      <h2 className="font-display text-xl text-[#1B2C5A] flex items-center gap-2"><SearchIcon className="w-5 h-5 text-[#9DCD3F]" /> Quick Student Search</h2>
      <div className="mt-3 relative">
        <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#475569]" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name or admission no..."
          className="w-full h-12 pl-10 pr-3 rounded-full bg-white border border-[#E2E8F0] text-sm focus:outline-none focus:border-[#1B2C5A]"
          data-testid="search-input"
        />
      </div>
      <p className="text-xs text-[#475569] mt-2">Showing {results.length} of {all.length} students</p>

      <ul className="mt-3 space-y-2">
        {results.map((s) => (
          <li key={s.id} className="p-3 rounded-xl bg-white border border-[#E2E8F0]" data-testid={`search-result-${s.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#1B2C5A]/5 text-[#1B2C5A] grid place-items-center text-xs font-medium">
                {(s.full_name || "").split(" ").slice(0, 2).map((p) => p[0]).join("")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-[#1B2C5A] truncate">{s.full_name}</div>
                <div className="text-xs text-[#475569]">{s.admission_no} · {s.grade} {s.section && `· ${s.section}`}</div>
              </div>
            </div>
            {(s.guardian_name || s.guardian_phone || s.guardian_email) && (
              <div className="mt-3 pt-3 border-t border-[#E2E8F0] text-xs text-[#475569] space-y-1">
                <div>Guardian: <span className="text-[#1B2C5A] font-medium">{s.guardian_name || "—"}</span></div>
                {s.guardian_phone && (
                  <a href={`tel:${s.guardian_phone}`} className="flex items-center gap-2 text-[#1B2C5A]"><Phone className="w-3.5 h-3.5 text-[#9DCD3F]" /> {s.guardian_phone}</a>
                )}
                {s.guardian_email && (
                  <a href={`mailto:${s.guardian_email}`} className="flex items-center gap-2 text-[#1B2C5A]"><Mail className="w-3.5 h-3.5 text-[#9DCD3F]" /> {s.guardian_email}</a>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileSearch;
